import { Typography } from '@mui/material'
import { EmptyState } from 'common/components/EmptyState'
import { Lock } from 'lucide-react'

/**
 * Shown in place of an owner/admin-only settings page when the current user is
 * a collaborator. The tab stays visible and clickable (so the feature is
 * discoverable), but the content explains who can access it and what to do
 * instead of leaving the user to hunt for a missing tab.
 */
export const NoAccessPanel = ({ feature = 'This page' }) => (
  <EmptyState
    isFullPage
    icon={<Lock size={44} style={{ strokeWidth: 1, color: 'currentColor' }} />}
    label={
      <Typography
        variant="textPrimary"
        color="text.secondary"
        sx={{ maxWidth: 440, textAlign: 'center' }}
      >
        {feature} is managed by organization owners and admins. Ask an org admin if you need
        changes here.
      </Typography>
    }
  />
)
